import type { ReactNode } from "react";
import { Grid, Typography, useMediaQuery } from "@mui/material";
import { dateUtil } from "@sdeapps/react-core";
import TodayIcon from "@mui/icons-material/Today";
import type { TypographyProps } from "@mui/material";

interface DisplayCommandeDateProps extends Omit<TypographyProps, "sx"> {
  dateCommande: string | Date;
  item?: boolean;
  noIcon?: boolean;
}

function DisplayCommandeDate({
  dateCommande,
  item = false,
  noIcon = false,
  ...typographyProps
}: Readonly<DisplayCommandeDateProps>): ReactNode {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  return (
    <Grid container size={item ? "auto" : undefined} sx={{ gap: 1, alignItems: "center" }}>
      {!noIcon && (
        <Grid container size="auto">
          <TodayIcon fontSize="small" color="primary" />
        </Grid>
      )}
      <Grid size="grow">
        <Typography {...typographyProps} variant={isSmallScreen ? "body2" : "body1"}>
          {dateUtil.format(dateCommande, "dd/MM/yyyy")}
        </Typography>
      </Grid>
    </Grid>
  );
}

export default DisplayCommandeDate;
